<template>
  <div id="app" :class="''+mode">
    <div id="page">
      <div v-if="!isMobile">
        <p class="paragraph">
          Please note that this is a webview mode of the TBD app, you can only use this on a mobile device.

        </p>
        <p class="paragraph">
          Please download the android app here.
          <br>
          <a target="_blank" href="https://play.google.com/store/apps/details?id=zw.co.kamifatech.tbd" class="btn btn-3d btn-m  mb-3 rounded-5 text-uppercase font-900 shadow-s border-red2-dark bg-red2-light mb-3">
            Play Store
          </a>
        </p>

        <p class="paragraph">
          Please visit the iOS web version <a href="https://app.todaysbusinesswomen.org/">here.</a>
          <br>
          <a target="_blank" href="https://app.todaysbusinesswomen.org/">https://app.todaysbusinesswomen.org/</a>
        </p>
      </div>
      <router-view v-else></router-view>
    </div>
  </div>
</template>

<script>

export default {
  mounted() {
    console.log(this.isMobile);
  },
  name: "App",

  methods: {

  },
  computed: {
    mode() {
      return this.$store.getters.mode
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
